<lib-page-layout>
  <lib-title-navbar
    pageHeader
    title="Alerty o gierkach w okolicy"
    [interceptBack]="true"
    (actionOnBack)="cancel()"></lib-title-navbar>

  <div class="or-mx-12-px or-mt-32-px">
    @let filterValues = notificationsValues();

    <ion-toggle
      justify="space-between"
      alignment="center"
      [checked]="filterValues.isEnabled"
      class="or-d-flex"
      (ionChange)="toggleNotifications($event)">
      <div class="or-head-md">Alerty o gierkach</div>
      <div class="or-note-sm or-color-secondary-2 white-space-normal or-mt-4-px">
        Otrzymuj powiadomienia o nowych gierkach w okolicy (publicznych)
      </div>
    </ion-toggle>

    <div class="custom-divider or-w-90-pc or-my-28-px"></div>

    @if (!filterValues.isEnabled) {
      <div
        class="or-bg-shade border-shade border-radius-8 or-d-flex or-align-items-center or-justify-content-center or-p-12-px">
        <or-icon name="learn-more" size="xs" class="or-color-secondary-6 or-mr-8-px" />
        <span class="or-text-sm or-color-secondary-6">Włącz alerty powyżej, aby odblokować ustawienia</span>
      </div>
    } @else {
      <div>
        <span class="or-head-md">Lokalizacja</span>
        <div class="or-d-flex or-align-items-center or-mt-12-px">
          <div
            class="border-shade border-radius-4 or-d-flex or-flex-1 or-bg-white or-p-8-px or-text-md or-align-items-center or-mr-12-px">
            <div
              (click)="openLocationPicker()"
              class="or-d-flex or-flex-1 or-align-items-center or-justify-content-between or-cursor-pointer">
              <div [ngClass]="selectedLocation() ? 'or-color-black' : 'or-color-secondary-2'">
                {{ selectedLocation()?.name ?? 'Zlokalizuj się' }}
              </div>
              <img src="assets/icons/dropdown-icon.svg" class="or-ml-8-px" />
            </div>
            @if (selectedLocation()) {
              <ion-icon
                name="close"
                (click)="clearLocation()"
                class="or-ml-8-px or-color-secondary-2 or-cursor-pointer"></ion-icon>
            }
          </div>

          <div
            (click)="openDistance()"
            [ngClass]="{ disabled: !selectedLocation() }"
            class="border-shade border-radius-4 or-d-flex or-w-25-pc or-bg-white or-p-8-px or-text-md text-no-wrap or-align-items-center or-justify-content-between or-cursor-pointer">
            {{ distanceLabel(filterValues.maxDistanceMeters) }}
            <img src="assets/icons/dropdown-icon.svg" class="or-ml-8-px" />
          </div>
        </div>
      </div>

      <div>
        <div class="or-mt-20-px">
          <span class="or-head-md">Godziny gierek</span>
          <div class="or-position-relative or-mt-24-px">
            <ion-range
              [dualKnobs]="true"
              [value]="{ lower: filterValues.time.hoursMin, upper: filterValues.time.hoursMax }"
              [min]="0"
              [max]="24"
              (ionInput)="onTimeChange($event)"
              class="or-mx-20-px">
            </ion-range>
            <div class="left-count or-text-md">{{ filterValues.time.hoursMin }}:00</div>
            <div class="right-count or-text-md">{{ filterValues.time.hoursMax }}:00</div>
          </div>

          <div class="or-align-items-center or-d-flex or-mt-4-px">
            <ion-checkbox
              [checked]="isAllDay()"
              (ionChange)="toggleAllDay($event)"
              labelPlacement="end"
              justify="start"
              class="or-head-sm">
              <span class="or-ml-8-px">Cały dzień</span>
            </ion-checkbox>
          </div>
        </div>

        <div class="or-mt-20-px">
          <span class="or-head-md">Poziom gry</span>
          <div class="or-mt-8-px or-d-flex overflow-x-auto">
            @for (level of gameLevels; track level) {
              <ion-chip
                class="or-head-xs border-radius-20 or-p-8-px or-w-auto or-d-inline-flex chips-width"
                [ngClass]="levelChips(level) ? 'chip-checked' : 'chip-unchecked'"
                (click)="isLevelChecked(level)">
                {{ gameLevelMapper[level] }}
              </ion-chip>
            }
          </div>
        </div>

        <div class="or-mt-24-px or-mb-24-px">
          <span class="or-head-md">Dni tygodnia</span>
          <div class="or-mt-8-px or-d-flex overflow-x-auto">
            @for (day of weekDays; track day) {
              <ion-chip
                class="or-head-xs border-radius-20 or-p-8-px or-w-auto or-d-inline-flex chips-width"
                [ngClass]="isDayChecked(day) ? 'chip-checked' : 'chip-unchecked'"
                (click)="selectWeekday(day)">
                {{ weekdaysMapper[day] }}
              </ion-chip>
            }
          </div>
          @if (isSelectAllWeekdaysVisible()) {
            <div
              (click)="selectAllWeekdays()"
              class="or-head-xs or-color-main-1 or-ml-8-px or-mt-8-px or-cursor-pointer">
              Zaznacz wszystkie
            </div>
          }
        </div>
      </div>
    }
  </div>

  <lib-page-actions pageActions>
    <button class="button-secondary-style or-h-48-px or-head-md or-w-100-pc" (click)="cancel()">Anuluj</button>
    <button
      class="button-primary-style or-h-48-px or-head-md or-w-100-pc"
      [ngClass]="{ 'disabled-button': !canSave() }"
      [disabled]="!canSave()"
      (click)="saveSettings()">
      Zapisz
    </button>
  </lib-page-actions>
</lib-page-layout>
